import React, { useState } from "react";
import Modal from "react-modal";
import ShareQRCode from "./ShareQRCode";
import ShareSocial from "./ShareSocial";
import ShareCopyLink from "./ShareCopyLink";
import ShareCopyCode from "./ShareCopyCode";

const Share = ({
    /** Hybrid control */
    isOpen: controlledIsOpen,
    onClose: controlledOnClose,

    /** Trigger content */
    children,

    /** Modal props */
    title,
    description = "",
    url = "",

    /** Toggle sections */
    showQRCode = true,
    showSocial = true,
    showCopyLink = true,
    showCopyCode = true,

    /** Sub-component props */
    qrProps = {},
    socialProps = {},
    copyProps = {},

    /** Styling overrides */
    className = "",
    style = {},

    /** Events */
    onOpen,
    onClose,

    /** Type */
    type = "url", // url | code
    code = "",
}) => {
    const [internalOpen, setInternalOpen] = useState(false);

    const isControlled = typeof controlledIsOpen === "boolean";
    const isOpen = isControlled ? controlledIsOpen : internalOpen;

    const handleOpen = () => {
        if (!isControlled) setInternalOpen(true);
        onOpen?.();
    };

    const handleClose = () => {
        if (!isControlled) setInternalOpen(false);
        onClose?.();
        controlledOnClose?.();
    };

    return (
        <>
            <span onClick={handleOpen} style={{ cursor: "pointer", display: "inline-block" }}>
                {children}
            </span>

            <Modal
                isOpen={isOpen}
                onRequestClose={handleClose}
                ariaHideApp={false}
                className="react-modal share-modal"
            >
                <div
                    className={`p-4 ${className}`}
                    style={{ maxWidth: "420px", ...style }}
                >
                    <div className="border-0 flex-column position-relative">
                        <h5>{title}</h5>
                        {description && <p className="text-muted small mb-0">{description}</p>}
                        <i
                            className="fas fa-times"
                            onClick={handleClose}
                            style={{
                                position: "absolute",
                                top: -14,
                                right: -7,
                                fontSize: 16
                            }}
                        />
                    </div>

                    <div>
                        {showQRCode && !!url && <ShareQRCode url={`${url}`} {...qrProps} />}
                        {showQRCode && !!code && <ShareQRCode url={`${code}`} {...qrProps} />}
                        {showSocial && <ShareSocial url={url} {...socialProps} />}
                        {type === "url" && !!url && showCopyLink && <ShareCopyLink url={url} {...copyProps} />}
                        {type === "code" && !!code && showCopyCode && <ShareCopyCode code={code} {...copyProps} />}
                    </div>
                </div>
            </Modal>

            <style>{`
                .share-modal {
                    max-width: 400px;
                }
            `}</style>
        </>
    );
};

export default Share;
